'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHART_BACKGROUND_COLOR = exports.CHART_BACKGROUND_COLOR = 'rgba(237, 240, 242, 1)';
var CHART_BACKGROUND_COLOR_HOVER = exports.CHART_BACKGROUND_COLOR_HOVER = 'rgba(213, 220, 224, 1)';
var CHART_MAIN_COLOR = exports.CHART_MAIN_COLOR = 'rgba(99, 191, 146, 1)';
var CHART_MAIN_COLOR_HOVER = exports.CHART_MAIN_COLOR_HOVER = 'rgba(60, 146, 96, 1)';

var DEFAULT_INPUT_TEXT_COLOR = exports.DEFAULT_INPUT_TEXT_COLOR = 'light-gray';


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/mixins/colors.js
// module id = Ybtu
// module chunks = 0 1